<template>
    <div>
        <v-toolbar
            class="Vuely-toolbar"
            app
            :color="activeHeaderFilter.class"
            fixed
        >
            <div class="d-custom-flex align-items-center navbar-left"></div>
            <div class="navbar-right">
                <div class="v-menu v-menu--inline">
                    <img
                        class="logo-tat"
                        src="/admin/static/img/logo-tat.png"
                        alt=""
                    />
                </div>
                <v-btn
                    icon
                    large
                    @click="toggleFullScreen"
                    class="full-screen ma-0"
                >
                    <v-icon color="grey">fullscreen</v-icon>
                </v-btn>
            </div>
        </v-toolbar>
    </div>
</template>

<script>
import screenfull from 'screenfull'
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters(['activeHeaderFilter']),
    },
    methods: {
        toggleFullScreen() {
            if (screenfull.enabled) {
                screenfull.toggle()
            }
        },
    },
}
</script>
